import { Send } from "lucide-react"
import EstimationDownloadActions from "./EstimationDownloadActions.tsx"
import type { SelectedMaterial, UserData } from "../../../../types/calculadoraDeMateriales.ts"
import styles from "../CalculadoraDeMateriales.module.scss"

type CalculadoraPageHeaderProps = {
  headerTitle: string
  headerSubtitle: string | undefined
  isEstimacionDeCostos: boolean
  userData: UserData | null
  selectedMaterials: SelectedMaterial[]
  setShowSendQuotePopup: (v: boolean) => void
  handleSendQuoteClick: () => void
  hasChanges: () => boolean
  isEditMode: boolean
}

const CalculadoraPageHeader = ({
  headerTitle,
  headerSubtitle,
  isEstimacionDeCostos,
  userData,
  selectedMaterials,
  setShowSendQuotePopup,
  handleSendQuoteClick,
  hasChanges,
  isEditMode,
}: CalculadoraPageHeaderProps) => {
  return (
    <div className={styles.container_header}>
      <div className={styles.container_header_title}>
        <div className={styles.container_header_title_heading}>
          <h1 className={styles.container_header_title_text}>{headerTitle}</h1>
          {headerSubtitle && <p className={styles.container_header_title_subtitle}>{headerSubtitle}</p>}
        </div>
      </div>
      <div className={styles.container_header_buttons}>
        {isEstimacionDeCostos ? (
          <EstimationDownloadActions
            userData={userData}
            materials={selectedMaterials}
            setShowSendQuotePopup={setShowSendQuotePopup}
            className={styles.container_header_download}
            closePreview={() => {}}
            previewPopUp={false}
          />
        ) : (
          <button
            className={styles.container_header_quoteBtn}
            onClick={handleSendQuoteClick}
            disabled={isEditMode ? !hasChanges() : selectedMaterials.length === 0}
          >
            <Send size={16} style={{ minHeight: "1.6rem", minWidth: "1.6rem" }} />
            <span>{isEditMode ? "Guardar cambios" : "Enviar para cotizar"}</span>
          </button>
        )}
      </div>
    </div>
  )
}

export default CalculadoraPageHeader
